(() => {
  if (window.VAGBoosterCatalogFormsLoaded) return;
  window.VAGBoosterCatalogFormsLoaded = true;

  const fallbackLabels = {
    'temat': 'Temat',
    'imię': 'Imię',
    'name': 'Name',
    'nazwa': 'Imię',
    'email': 'Email',
    'typ silnika': 'Silnik',
    'typ sterownika': 'Sterownik',
    'usługa': 'Usługa',
    'kod silnika': 'Kod silnika',
    'numer ecu': 'Nr ECU',
    'programator': 'Programator',
    'vin': 'VIN',
    'model auta': 'Auto',
    'marka i model': 'Auto',
    'moc seryjna': 'Moc seryjna',
    'skrzynia': 'Skrzynia',
    'cel': 'Cel',
    'wiadomość': 'Wiadomość',
    'message': 'Message',
    'komentarz': 'Wiadomość',
    'comment': 'Message',
    'produkt': 'Produkt',
    'link': 'Link produktu'
  };

  const cleanLabel = (name) => {
    const match = name.match(/^contact\[(.*)\]$/);
    const raw = (match ? match[1] : name).trim();
    return fallbackLabels[raw.toLowerCase()] || raw;
  };

  const fieldLabel = (form, name) => {
    const field = Array.from(form.elements).find((element) => element.name === name);
    if (field && field.id) {
      const label = form.querySelector('label[for="' + field.id + '"]');
      if (label && label.textContent.trim()) return label.textContent.trim();
    }
    return cleanLabel(name);
  };

  const init = () => {
    document.querySelectorAll('form[data-vb-sms-form], form[data-vb-whatsapp-form]').forEach((form) => {
      if (form.dataset.vbMessageReady === 'true') return;
      form.dataset.vbMessageReady = 'true';

      const productField = Array.from(form.elements).find((element) => element.name === 'contact[produkt]');
      const linkField = Array.from(form.elements).find((element) => element.name === 'contact[link]');
      const productHeading = document.querySelector('.product__title h1, .product__info-wrapper h1');
      if (productField && !productField.value) {
        productField.value = form.dataset.vbProduct || (productHeading && productHeading.textContent.trim()) || 'VAGBooster';
      }
      if (linkField && !linkField.value) {
        linkField.value = form.dataset.vbProductUrl || (window.location.origin + window.location.pathname);
      }

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        if (!form.reportValidity()) return;

        const data = new FormData(form);
        const selectedTopic = String(data.get('contact[temat]') || '').trim();
        const defaultTopic = form.dataset.vbTopic || 'VAGBooster - zapytanie';
        const lines = [selectedTopic ? 'VAGBooster: ' + selectedTopic : defaultTopic];
        const currentProduct = form.dataset.vbProduct || (productHeading && productHeading.textContent.trim()) || 'VAGBooster';
        const currentLink = form.dataset.vbProductUrl || (window.location.origin + window.location.pathname);
        lines.push('Produkt: ' + currentProduct);
        lines.push('Link produktu: ' + currentLink);

        for (const [name, rawValue] of data.entries()) {
          if (
            name === 'contact[temat]' ||
            name === 'contact[produkt]' ||
            name === 'contact[link]' ||
            name === 'form_type' ||
            name === 'utf8'
          ) continue;
          const value = String(rawValue).trim();
          if (!value) continue;
          lines.push(fieldLabel(form, name) + ': ' + value);
        }

        const message = encodeURIComponent(lines.join('\n'));
        if (form.hasAttribute('data-vb-whatsapp-form')) {
          const number = form.dataset.whatsappNumber || '48881492556';
          window.location.assign('https://wa.me/' + number + '?text=' + message);
          return;
        }

        const number = form.dataset.smsNumber || '48881492556';
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
          (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
        const separator = isIOS ? '&' : '?';
        window.location.assign('sms:+' + number + separator + 'body=' + message);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();